import { navigationConfig } from '../config/navigation.config';

export interface INavDisplayOptions {
   displayEdgeLevels: number;
   displayEdgeGroups: string;
   displayEdgeLabels: boolean;
}

export const NAV_DISPLAY_OPTIONS_INITIAL_STATE: INavDisplayOptions = {
   displayEdgeLevels: 1,      // 1: 1 Ebene
   displayEdgeGroups: navigationConfig.displayDefaultEdgeGroup,
   displayEdgeLabels: true
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-display-options.interface.ts